import React, { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Navbar from "./website/components/Layout/Navbar/Navbar";
import Footer from "./website/components/Layout/Footer/Footer";
import { injectAllScripts } from "./website/utils/utils";
import "./App.css";
import scriptsDataComponent from "./website/cms-data/scripts.json";

//lazy loading
const HomeComponent = lazy(() => import('./website/pages/Homepage/Homepage'));
const PlatformComponent = lazy(() => import('./website/pages/Platform/Platform'));
const ProductComponent = lazy(() => import('./website/pages/Inventory/Inventory'));
const AboutUsComponent = lazy(() => import('./website/pages/AboutUs/AboutUs'));
const RegisterComponent = lazy(() => import('./website/pages/Register/Register'));
const MSAComponent = lazy(() => import('./website/pages/MSA/Msa'));
const PrivacyComponent = lazy(() => import('./website/pages/Privacy/Privacy'));
const SitemapComponent = lazy(() => import('./website/pages/Sitemap/Sitemap'));
const PressComponent = lazy(() => import('./website/pages/Press/PressHome/PressHome'));
const BlogsRouter = lazy(() => import('./website/pages/Blogs/BlogsRouter'));
const IndustriesRouter = lazy(() => import('./website/pages/IndustriesPages/IndustriesRouter'));
const IntelligentDocumentProcessorComponent= lazy(() => import('./website/pages/IntelligentDocumentProcessor/IntelligentDocumentProcessor'));
const HelpSystemRouter = lazy(() => import('./helpsystem/HelpSystemRouter'));
const HelpDoc = lazy(() => import('./helpsystem/pages/HelpDoc/HelpDoc'));
const OurPartners = lazy(() => import('./website/pages/OurPartners/OurPartners'));
const CustomerStories = lazy(() => import('./website/pages/CustomerStories/CustomerStories'));
const Pricing = lazy(() => import('./website/pages/Pricing/Pricing'));
const InvoiceIntelligence = lazy(() => import('./website/pages/InvoiceIntelligence/InvoiceIntelligence'));
const ReceiptsIntelligence = lazy(() => import('./website/pages/ReceiptsIntelligence/ReceiptsIntelligence'));
const ContractIntelligence = lazy(() => import('./website/pages/ContractIntelligence/ContractIntelligence'));
const ExploreVideos = lazy(() => import('./website/pages/videos/Video'))


const App = () => {
  const [sidebarShow, setSideBarShow] = useState(false);

  useEffect(() => {
    const bodySrcollLock = () => {
      if (sidebarShow) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "hidden auto";
      }
    };

    bodySrcollLock();
  }, [sidebarShow]);

  useEffect(() => {
    injectAllScripts(scriptsDataComponent)
  }, [])

  const host= window?.location?.host
  const subdomain = host.split('.')[0]
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isIframe = params.get('iframe')

  //testing purpose
  if(subdomain==='help' || subdomain==='support-new-website' || subdomain==='razorthink-pre-prod-help'){
    return (
        <Router>
          <Suspense fallback={<></>}>
            {!isIframe && <Navbar sidebarShow={sidebarShow} toggleSideBar={setSideBarShow} isSubdomain={true} />}
            <Route render={(props) => <HelpSystemRouter {...props} isIframe={isIframe} />} />
            {!isIframe && <Footer isSubdomain={true}/>}
          </Suspense>
        </Router>
    )
  }


  return (
    <>
      <Router>
        <Suspense fallback={<></>}>
          <Navbar sidebarShow={sidebarShow} toggleSideBar={setSideBarShow} />
          <Switch>
            <Route exact path='/' render={(props) => <HomeComponent {...props} />} />
            {/*<Route exact path='/platform' render={(props) => <PlatformComponent {...props} />} />*/}
            <Route exact path='/ai-demand-forecasting' render={(props) => <ProductComponent {...props} />} />
            <Route exact path='/intelligent-document-processor' render={(props) => <IntelligentDocumentProcessorComponent {...props} />} />
            <Route exact path='/about-us' render={(props) => <AboutUsComponent {...props} />} />
            <Route exact path='/register' render={(props) => <RegisterComponent {...props} />} />
            <Route exact path='/msa-terms' render={(props) => <MSAComponent {...props} />} />
            <Route exact path='/privacy-policy' render={(props) => <PrivacyComponent {...props} />} />
            <Route exact path='/sitemap' render={(props) => <SitemapComponent {...props} />} />
            <Route exact path='/press' render={(props) => <PressComponent {...props} />}/>
            <Route path='/blog' render={(props) => <BlogsRouter {...props} />}/>
            {/*<Route path='/support' render={(props) => <HelpSystemRouter {...props} />}/>*/}
            {/*<Route path='/helpdoc' render={(props) => <HelpDoc {...props} />}/>*/}
            <Route exact path='/our-partners' render={(props) => <OurPartners {...props} />} />
            <Route exact path='/customer-stories' render={(props) => <CustomerStories {...props} />} />
            <Route exact path='/pricing' render={(props) => <Pricing {...props} />} />
            <Route exact path='/invoice-intelligence' render={(props) => <InvoiceIntelligence {...props} />} />
            <Route exact path='/receipts-intelligence' render={(props) => <ReceiptsIntelligence {...props} />} />
            <Route exact path='/contract-intelligence' render={(props) => <ContractIntelligence {...props} />} />
            <Route exact path='/explainer-video' render={(props) => <ExploreVideos {...props} />}/>
            <Redirect to='/' />
          </Switch>
          <Footer />
        </Suspense>
      </Router>
    </>
  );
};

export default App;
